import Image from "next/legacy/image";
import { blurDataURL } from "../../../utils/constants/images";

const PeopleProfileCard = ({ member }) => {
  return (
    <>
      <div className="space-y-6 xl:space-y-10 ">
        <div className="mx-auto h-40 w-40 rounded-full xl:w-56 xl:h-56 relative">
          <Image
            src={member.profile_picture}
            alt="Board Member Avatar"
            objectFit="cover"
            layout="fill"
            quality={100}
            placeholder="blur"
            blurDataURL={blurDataURL}
            className="mx-auto h-40 w-40 rounded-full xl:w-56 xl:h-56 relative"
          />
        </div>

        <div className="space-y-2 xl:flex xl:items-center xl:justify-between">
          <div className="font-medium text-lg leading-6 space-y-1">
            <h3 className="text-white">{`${member.first_name} ${member.last_name}`}</h3>
            <p className="text-red-400 dark:text-green-400">
              {member.job_title}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PeopleProfileCard;
